import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2fd0d1b8&scoped=true"
import script from "./_add.js?vue&type=script&lang=js&external"
export * from "./_add.js?vue&type=script&lang=js&external"
import style0 from "./_add.scss?vue&type=style&index=0&id=2fd0d1b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0d1b8",
  null
  
)

export default component.exports